import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LanguageService } from '../services/language.service';

export const localizedLanguageGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const language = inject(LanguageService);
  const router = inject(Router);
  const requested = route.paramMap.get('lang')?.toLowerCase() ?? '';

  const separatorIndex = state.url.search(/[?#]/);
  const path = separatorIndex === -1 ? state.url : state.url.slice(0, separatorIndex);
  const suffix = separatorIndex === -1 ? '' : state.url.slice(separatorIndex);
  const serializedSegments = path.split('/').filter(Boolean);

  if (language.isSupported(requested)) {
    if (requested !== 'fr' && ['mentions-legales', 'confidentialite', 'cgu', 'api'].includes(serializedSegments[1])) {
      return router.parseUrl(`/fr/${serializedSegments.slice(1).join('/')}${suffix}`);
    }
    language.setLang(requested);

    // Répare aussi les URLs produites avant ce correctif (`/fr/fr/...`).
    if (serializedSegments[0]?.toLowerCase() === requested && serializedSegments[1]?.toLowerCase() === requested) {
      const canonicalSegments = serializedSegments.filter(
        (segment, index) =>
          index === 0 ||
          segment.toLowerCase() !== requested ||
          serializedSegments[index - 1]?.toLowerCase() !== requested
      );
      return router.parseUrl(`/${canonicalSegments.join('/')}${suffix}`);
    }

    return true;
  }

  // LangUrlSerializer préfixe déjà les liens neutres lors de leur sérialisation.
  // Pendant une navigation Angular, `requested` provient cependant de l'UrlTree
  // original (`/contact`) tandis que `state.url` vaut déjà `/fr/contact`. Ne pas
  // préfixer une seconde fois, sinon le clic aboutit à `/fr/fr/contact`.
  if (language.isSupported(serializedSegments[0]?.toLowerCase() ?? '')) {
    return router.parseUrl(state.url);
  }

  const preferred = language.currentLang();
  const absoluteUrl = state.url.startsWith('/') ? state.url : `/${state.url}`;
  return router.parseUrl(`/${preferred}${absoluteUrl}`);
};
